import { render, staticRenderFns } from "./ProfileDocuments.vue?vue&type=template&id=55a067c9&scoped=true&"
import script from "./ProfileDocuments.vue?vue&type=script&lang=js&"
export * from "./ProfileDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDocuments.vue?vue&type=style&index=0&id=55a067c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a067c9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55a067c9')) {
      api.createRecord('55a067c9', component.options)
    } else {
      api.reload('55a067c9', component.options)
    }
    module.hot.accept("./ProfileDocuments.vue?vue&type=template&id=55a067c9&scoped=true&", function () {
      api.rerender('55a067c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ProfileDocuments.vue"
export default component.exports